<template>
  <div class="remanejamento">
    <div class="row">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-primary btn-voltar"
          @click="$router.back()"
        >
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <h2 class="page-header">Remanejar emenda</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <h3>Dados da Emenda</h3>
      </div>
      <div class="col-xs-12 col-md-3">
        <p>
          <span class="font-lg"> <b>Número:</b> {{ numero }} / {{ ano }} </span>
        </p>
      </div>
      <div class="col-xs-12 col-md-3">
        <p>
          <span class="font-lg">
            <b>Valor:</b> {{ formatarMoeda(valor || 0) }}
          </span>
        </p>
      </div>
      <div class="col-xs-12 col-md-6">
        <p>
          <span class="font-lg"> <b>Vereador:</b> {{ vereador.nome }} </span>
        </p>
      </div>
      <div class="col-xs-12">
        <p>
          <span class="font-lg"> <b>Descrição:</b> {{ descricao }} </span>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <h3>Nova Emenda</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-md-3">
        <div :class="['form-group', { 'has-error': errors.has('numero') }]">
          <label for="numero" class="control-label">
            Emenda nº
          </label>
          <div class="input-group">
            <span class="input-group-addon">
              Nº
              <!-- <font-awesome-icon :icon="'sort-numeric-up-alt'" /> -->
            </span>
            <the-mask
              id="numero"
              ref="numero"
              name="numero"
              class="form-control"
              :mask="'####'"
              data-vv-as="Emenda nº"
              v-validate="'required|numeric'"
              v-model="model.numero"
              disabled="disabled"
            />
          </div>
          <input-error-message
            v-if="errors.has('numero')"
            :message="errors.first('numero')"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-4">
        <div :class="['form-group', { 'has-error': errors.has('valor') }]">
          <label for="valor" class="control-label">
            Valor a remanejar
          </label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'money-bill'" />
            </span>
            <money
              id="valor"
              ref="valor"
              name="valor"
              v-validate="'required|min_value:0.01'"
              v-model="model.valor"
              class="form-control"
              v-bind="{
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
              }"
            />
          </div>
          <input-error-message
            v-if="errors.has('valor')"
            :message="errors.first('valor')"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-3">
        <div class="form-group">
          <label for="sigla_orgao" class="control-label">Sigla do órgão</label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'landmark'" />
            </span>
            <select
              id="sigla_orgao"
              ref="sigla_orgao"
              name="sigla_orgao"
              class="form-control select-selected"
              v-model="model.sigla_orgao"
              v-validate="'required'"
              @change="loadNomeSecretaria"
            >
              <option v-for="orgao in orgaos" :key="orgao.id">
                {{ orgao.sigla }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-9">
        <div class="form-group">
          <label for="nome_orgao" class="primary">Nome do orgão</label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'signature'" />
            </span>
            <input
              id="nome_orgao"
              ref="nome_orgao"
              name="nome_orgao"
              v-model="model.nome_orgao"
              class="form-control"
              v-validate="'required'"
              type="text"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div :class="['form-group', { 'has-error': errors.has('descricao') }]">
          <label for="descricao" class="control-label">Descrição</label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'tags'" />
            </span>
            <textarea
              id="descricao"
              ref="descricao"
              name="descricao"
              rows="3"
              data-vv-as="descrição"
              v-model="model.descricao"
              placeholder="Descrição"
              class="form-control"
              maxlength="500"
              v-validate="'required'"
            >
            </textarea>
            <span class="input-group-addon">
              {{ 500 - model.descricao.length }}
            </span>
          </div>
          <input-error-message
            v-if="errors.has('descricao')"
            :message="errors.first('descricao')"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div :class="['form-group', { 'has-error': errors.has('observacao') }]">
          <label for="observacao" class="control-label">Observação</label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'tags'" />
            </span>
            <textarea
              id="observacao"
              ref="observacao"
              name="observacao"
              rows="3"
              v-model="model.observacao"
              placeholder="Observação"
              class="form-control"
              maxlength="2000"
            >
            </textarea>
            <div class="input-group-addon">
              {{ 2000 - model.observacao.length }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div
          :class="['form-group', { 'has-error': errors.has('termo_busca') }]"
        >
          <label for="termo_busca" class="control-label">Termo de busca</label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'search'" />
            </span>
            <input
              id="termo_busca"
              ref="termo_busca"
              name="termo_busca"
              v-model="model.termo_busca"
              placeholder="Termos de busca"
              class="form-control"
              maxlength="100"
              type="text"
            />
            <div class="input-group-addon">
              {{ 100 - model.termo_busca.length }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group"></div>
    <div class="row">
      <div class="col-xs-12">
        <button
          class="btn btn-default"
          @click="remanejar()"
          :disabled="isLoading"
        >
          <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          &nbsp;Remanejar emenda
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { InputErrorMessage } from '../../../../components'
import { formatarMoeda } from '@/utils'
import { TheMask } from 'vue-the-mask'
import { request } from '@/request'

export default {
  name: 'remanejamento',
  components: { InputErrorMessage, TheMask },
  props: {
    ano: {
      type: String
    },
    descricao: {
      type: String
    },
    id: {
      type: Number
    },
    nome_orgao: {
      type: String
    },
    numero: {
      type: Number
    },
    numero_processo: {
      type: String
    },
    observacao: {
      type: String
    },
    processos_pagamento: {
      type: Array
    },
    resumo_utilizacao: {
      type: String
    },
    saldo: {
      type: Number
    },
    sigla_orgao: {
      type: String
    },
    termo_busca: {
      type: String
    },
    valor: {
      type: String
    },
    vereador: {
      type: Object,
      default: () => ({ nome: '' })
    },
    vereador_id: {
      type: Number
    }
  },
  data() {
    return {
      isLoading: false,
      model: {
        id: null,
        valor: this.saldo,
        numero: this.numero,
        nome_orgao: this.nome_orgao,
        sigla_orgao: this.sigla_orgao,
        descricao: '',
        observacao: '',
        termo_busca: '',
        resumo_utilizacao: '',
        id_emenda_origem: this.id
      },
      orgaos: []
    }
  },
  beforeCreate() {
    const { id } = this.$route.params
    if (!id) {
      this.$router.push({ name: 'user_emendasparlamentares' })
    }
  },
  created() {
    this.loadSecretarias()
  },
  methods: {
    formatarMoeda,
    toggleLoading() {
      this.isLoading = !this.isLoading
    },
    async loadSecretarias() {
      try {
        const { data } = await request.get('unidade-organizacional/secretarias')
        this.orgaos = data
      } catch (error) {
        this.$toastr.e(
          'Houve um erro ao carregar as secretarias. Atualize a página e tente novamente'
        )
      }
    },
    loadNomeSecretaria() {
      const finder = secretaria => secretaria.sigla === this.model.sigla_orgao
      const orgao = this.orgaos.find(finder)
      this.model.nome_orgao = orgao.nome
    },
    async remanejar() {
      if (this.saldo - this.model.valor < 0) {
        this.$toastr.e(
          'Saldo insuficiente para remanejamento da emenda. Saldo atual: ' +
            formatarMoeda(this.saldo)
        )
        this.$refs.valor.$el.focus()
        return
      }

      const isValid = await this.$validator.validateAll()

      if (isValid) {
        this.toggleLoading()
        try {
          const { data } = await request.post(
            'emendas/remajenar',
            this.formValues
          )

          this.$toastr.s('Remanejamento efetuado com sucesso.')
          return this.$router.push({ name: 'user_emendasparlamentares' })
        } catch (error) {
          const { data, status } = error.response
          let msg = ''
          switch (status) {
            case 422:
              msg = data
              break

            default:
              msg = 'Houve um erro ao efetuar o remanejamento. Tente novamente.'
              break
          }
          return this.$toastr.e(msg)
        } finally {
          this.toggleLoading()
        }
      }

      const [error] = this.errors.items
      this.setInputFocus(this.$refs[error.field])

      return this.$toastr.e(error.msg)
    },
    setInputFocus(element) {
      if (element instanceof HTMLElement) {
        element.focus()
      } else {
        element.$el.focus()
      }
    }
  },
  computed: {
    formValues() {
      return {
        id_origin: this.id,
        ...this.$props,
        ...this.model
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/emendas-parlamentares/emendas/Remanejamento.vue